import {ConfigurationScreen} from "../screens";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import * as MainSlice from "../store/mainSlice";
import {Routes} from "../utils";


export default function ConfigurationContainer(props) {
    const dispatch = useDispatch()
    const store = useSelector(({main}) => ({
        dimensions: main.dimensions,
        config: main.config,
    }))
    const navigate = useNavigate()


    const handleSubmit = (data) => {
        const config = {...store.config}
        if (data.height > 220) {
            config.height = 210
        } else if (data.height === 220) {
            config.height = 220
        } else if (data.height >= 215) {
            config.height = 215
        } else if (data.height >= 210) {
            config.height = 210
        } else if (data.height >= 205) {
            config.height = 205
        } else if (data.height >= 200) {
            config.height = 200
        }

        if (data.width > 120) {
            config.width = 100
        } else if (data.width >= 120) {
            config.width = 110
        } else if (data.width >= 110) {
            config.width = 100
        } else if (data.width >= 100) {
            config.width = 90
        } else if (data.width >= 90) {
            config.width = 80
        }
        dispatch(MainSlice.setDimensions(data))
        dispatch(MainSlice.setConfig(config))
        navigate(Routes.view)
    }

    return (
        <ConfigurationScreen
            dimensions={store.dimensions}
            onSubmit={handleSubmit}
        />
    )
}
